import { render, staticRenderFns } from "./GroupOptionViewPopover.vue?vue&type=template&id=0ba75887&"
import script from "./GroupOptionViewPopover.vue?vue&type=script&lang=js&"
export * from "./GroupOptionViewPopover.vue?vue&type=script&lang=js&"
import style0 from "./GroupOptionViewPopover.vue?vue&type=style&index=0&id=0ba75887&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports